module.exports = __webpack_public_path__ + "img/404.761b4833.png";